export default "__VITE_ASSET__B493HSAt__"